// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3c41b3e6] tbody tr td:first-child{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
